import React from "react"
import "./notFound.css"
import logo from "./../../assets/Hermes.png"

function NotFound() {
  return (
    <>
      <img alt="" style={{ height: "6rem", marginTop: '2rem', marginLeft: '2rem' }} src={logo} />
      <div className="not-found">
        <h1 style={{ fontSize: '6rem', fontWeight: 'bold' }}>404</h1>
        <h1>La page recherchée n'existe pas.</h1>
      </div>
    </>
  )
}

export default NotFound;